import React from "react";

const RedemptionOrderList = React.lazy(() => import("src/pages/redemption_order/RedemptionOrderList"));

const redemption_order_route = [
    {
        path: "redemption-order-list",
        name: "Redemption Order List",
        element: RedemptionOrderList,
    },
];

export default redemption_order_route;
